export type Sort = 'popular' | 'new'

const sortToTypeIdMap: Record<Sort, number> = {
  popular: 1,
  new: 2,
}
const typeIdToSortMap = Object.fromEntries(
  Object.entries(sortToTypeIdMap).map(([s, id]) => [id, s])
)
export const getSortFromTypeId = (id: number): Sort | undefined =>
  typeIdToSortMap[id]
export const getTypeIdFromSort = (sort: Sort): number | undefined =>
  sortToTypeIdMap[sort]
